import { axios } from '@Root/API'

export const remove = id => {
	return axios.delete(`delete/cost-centre-module/${id}`)
}
